import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import NotFound from "components/NotFound";
import AuthTheme from "theme/Auth";
import PrivateTheme from "theme/Private";
import DashboardTheme from "theme/SubTheme/dashboard";
import AdminRoute from "./Routes";
import { useDispatch, useSelector } from "react-redux";
import { getCoinsListApi, getSettings, viewUser } from "store/actions";
import { areCookiesEnabled } from "helpers/common";
import PermissionGate from "components/PermissionGate";
function Routs() {
  const { user } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSettings());
    areCookiesEnabled();
  }, []);

  useEffect(() => {
    if (user?._id) {
      dispatch(getCoinsListApi({}));
    }
  }, [user]);

  return (
    <Routes>
      <Route element={<AuthTheme />}>
        <Route index element={<Navigate to="/login" />} />
        {AdminRoute.map((data, key) => (
          <Route key={key} path={data.path} element={data.component} />
        ))}
      </Route>

      <Route path="/admin/" element={<DashboardTheme />}>
        <Route index element={<Navigate to="/admin/users" />} />
        {AdminRoute.map((data, key) => (
          <Route
            key={key}
            path={data.path}
            element={
              <ProtectedRoute
                permission={data.permission}
                is_permission={data.is_permission}
              >
                {data.component}
              </ProtectedRoute>
            }
          />
        ))}
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}



export const ProtectedRoute = ({ permission, is_permission, children }) => {
  const { user } = useSelector(({ Auth }) => Auth);
  const dispatch = useDispatch();

  const [authChecked, setAuthChecked] = useState(false); // To track if auth check is done

  useEffect(() => {
    const checkAuth = async () => {
      if (user?._id) {
        setAuthChecked(true);
        return;
      }
      try {
        await dispatch(viewUser({})); // Dispatch the action to check authentication
      } catch (error) {
        console.error("Error checking auth:", error);
      } finally {
        setAuthChecked(true); // Mark auth check as completed
      }
    };

    checkAuth();
  }, [dispatch, user?._id]);

  // While checking auth, show a loading indicator
  if (!authChecked) {
    return <p>Loading...</p>;
  }

  if (user?._id) {
    if (is_permission && permission) {
      return (
        <PermissionGate permission={permission} fallback={<Navigate to="/login" />}>
          {children}
        </PermissionGate>
      );
    }
    return children;
  }

  // If not authenticated, redirect to the login page
  return <Navigate to="/login" />;
};

export default Routs;
